import { useState } from 'react'

interface CompanyLogoProps {
  domain: string | undefined
  size?: number
}

export function CompanyLogo({ domain, size = 32 }: CompanyLogoProps) {
  const [hasError, setHasError] = useState(false)

  if (!domain || hasError) {
    const initials = domain ? domain.slice(0, 2).toUpperCase() : '??'
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: 'var(--color-kumo-fill)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size * 0.375,
          fontWeight: 600,
          color: 'var(--text-color-kumo-subtle)',
          flexShrink: 0,
        }}
      >
        {initials}
      </div>
    )
  }

  return (
    <img
      src={`https://img.logo.dev/${domain}?token=pk_Pa0Z9IptS5K2HtIOd9CliA&size=${size}&format=png`}
      alt={`${domain} logo`}
      width={size}
      height={size}
      loading="lazy"
      onError={() => setHasError(true)}
      style={{ borderRadius: '50%', flexShrink: 0 }}
    />
  )
}
